import Controller, { OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FormAPI, ImageAPI, FieldAPI, InputAPI, ButtonAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from './../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import ConfigurationService from '../../services/configuration-services';
import { Inject } from '@odinjs/odin';
import { LayoutData } from '../../app/types';
import { confirmationFieldValidator, CONFIRMATION_FIELD_VALID, optionsValidator } from '../../utils/user-util';

@Controller({ fragment: 'password-reset', component: 'root-layout' })
class PasswordResetController extends BaseController {

  @Inject('password-form')
  passwordForm: FormAPI;

  @Inject('logo-image')
  imageHeader: ImageAPI;

  @Inject('password-field')
  passwordField: FieldAPI;

  @Inject('confirm-password-field')
  passwordConfirmationField: FieldAPI;

  @Inject('confirm-password-input')
  inputConfirmPassword: InputAPI;

  @Inject('password-admit-button')
  buttonCreate: ButtonAPI;

  @Inject('panel-loader-action')
  panelLoaderApi: PanelAPI;

  password: string;
  confirmPassword: string;

  @OnMount({ target: ['root-layout'] })
  onLayoutMount(): void {
    const { imageHeader } = this;
    ConfigurationService.getConfigurationData().then((layoutData: LayoutData) => {
      imageHeader.setSrc(layoutData.dsUrlLogoHeader);
    });
    const token = this.historyService.getCurrentRouteQueryParams().token || '';
    HttpService.get(APPLICATION_ENDPOINTS.POST_RESET_PASSWORD_VALIDITY, { token })
      .catch(() => this.historyService.push(APPLICATION_ROUTES.FORGET_PASSWORD_RESET_FAILURE));
  }

  @OnMount({ target: ['password-form-panel'] })
  onFormMount(): void {
    this.passwordConfirmationField.addLocalValidator(CONFIRMATION_FIELD_VALID, () => {
      return confirmationFieldValidator(this.password, this.confirmPassword, 'pwd');
    }, optionsValidator());
  }

  @OnMount({ target: ['panel-loader-action'] })
  onMountLoader(): void {
    this.panelLoaderApi.setVisible(false);
  }

  @OnClick({ target: ['password-admit-button'] })
  onChangePasswordAdmitButton(): void {
    const token = this.historyService.getCurrentRouteQueryParams().token || '';
    const body = this.passwordForm.getRecord();
    this.panelLoaderApi.setVisible(true);

    HttpService.post(APPLICATION_ENDPOINTS.EMAILSENDER_SUCCESS_MAIL, { token }, { body })
      .then((response) => {
        if (response.status == 204 || response.status == 200) {
          this.historyService.push(APPLICATION_ROUTES.FORGET_PASSWORD_RESET_SUCCESS);
        }
      })
      .catch(() => this.historyService.push(APPLICATION_ROUTES.FORGET_PASSWORD_RESET_FAILURE));
  }

  @OnChange({ target: 'password-input' })
  async onPasswordChange(event: ChangeEvent<string>): Promise<void> {
    this.password = event.value as string;

    const confirmPassword = this.inputConfirmPassword.getValue();

    if (confirmPassword) {
      await this.passwordConfirmationField.validate();
    }
  }

  @OnChange({ target: 'confirm-password-input' })
  async onConfirmPasswordChange(event: ChangeEvent<string>): Promise<void> {
    this.confirmPassword = event.value as string;
    if(await this.passwordConfirmationField.validate()){
      this.buttonCreate.setEnabled(true)
    } else {
      this.buttonCreate.setEnabled(false);
    }
  }
}

export default PasswordResetController;
